module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-margin-top-30"
  }, [_c('control', {
    attrs: {
      "label": 'Period ' + (_vm.index + 1)
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodStart.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodStart",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodStart"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodStart),
      callback: function($$v) {
        _vm.periodStart = $$v
      },
      expression: "periodStart"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodStart')
    }
  }, [_vm._v("\n                    Loss of earnings period must be before the deceased's date of death (" + _vm._s(_vm.theDeceased.dateOfDeath) + ")\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEnd || !_vm.periodStartIsBeforeEnd()
    }
  }, [_vm._v("\n                    Start of loss of earnings period must be before end of loss of earnings period\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:periodEnd.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "periodEnd",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "name": "periodEnd"
    },
    on: {
      "input": _vm.calcRate
    },
    model: {
      value: (_vm.periodEnd),
      callback: function($$v) {
        _vm.periodEnd = $$v
      },
      expression: "periodEnd"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('periodEnd') || !_vm.endPeriodValid()
    }
  }, [_vm._v("\n                    Loss of earnings period end date must be before " + _vm._s(_vm.theDeceased.dateOfDeath) + "\n                ")])], 1)])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Earnings Per Annum"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodEmploymentType),
      expression: "periodEmploymentType"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodEmploymentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs--half u-margin-top-30"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodNetGross),
      expression: "periodNetGross"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    on: {
      "input": _vm.calcRate,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodValue),
      expression: "periodValue"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "period_value",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodValue)
    },
    on: {
      "focus": function($event) {
        _vm.periodValue = _vm.periodValue || ''
      },
      "blur": function($event) {
        _vm.periodValue = _vm.periodValue || 0
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodValue = $event.target.value
      }, _vm.calcRate]
    }
  })])])]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubtotal),
      expression: "showSubtotal"
    }],
    attrs: {
      "for": "sub_total",
      "label": "Subtotal",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodTotal),
      expression: "periodTotal"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.periodTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDelete) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deletePeriod
    }
  }, [_vm._v("Delete This Period")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr--margin-bottom"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-655a6580!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/estate/steps/heads-of-loss/EarningsPeriod.vue
// module id = 1723
// module chunks = 0